import { render, staticRenderFns } from "./spareGetDetailUpdate.vue?vue&type=template&id=37c959bf&scoped=true"
import script from "./spareGetDetailUpdate.vue?vue&type=script&lang=js"
export * from "./spareGetDetailUpdate.vue?vue&type=script&lang=js"
import style0 from "./spareGetDetailUpdate.vue?vue&type=style&index=0&id=37c959bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c959bf",
  null
  
)

export default component.exports